function getBreakpointValue(value, breakpoints, currentBreakpoint) {
  if (Array.isArray(value)) {
    return currentBreakpoint ? value[breakpoints.indexOf(currentBreakpoint)] : value[0];
  } else {
    return value;
  }
}
export default getBreakpointValue;